export default "__VITE_ASSET__Cd_f7Nrh__"